import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequest
} from "@/helper/requests"

const state = {
  scienceId: {
    info: null,
    loading: false,
    count: 0,
  }
}

const getters = {
  getScienceId: state => state.scienceId.items,
  getUserInfo: state => state.scienceId.info,
  isLoadingScienceId: state => state.scienceId.loading,
  saveScienceIdError: state => state.scienceId.error,
}

const actions = {
  loadScienceIdInfo: ({ commit, getters }, { finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.SCIENCE_ID.GET_DATA()
    if (!getters.isLoadingScienceId) {
      commit('SET_SCIENCE_ID_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_SCIENCE_ID_INFO', data)
          commit('SET_SCIENCE_ID_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_SCIENCE_ID_LOADING_END')
          commit('SAVE_SCIENCE_ID_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  postScienceId: ({ commit }, { science_id, data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.SCIENCE_ID.REGISTER_POST(science_id)
    commit('SET_SCIENCE_ID_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_SCIENCE_ID_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCIENCE_ID_LOADING_END')
        catcher(data, url)
      }
    )
  },
  searchScienceId: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.SCIENCE_ID.SEARCH()
    commit('SET_SCIENCE_ID_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_SCIENCE_ID_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCIENCE_ID_LOADING_END')
        catcher(data, url)
      }
    )
  },
  linkingScienceId: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.SCIENCE_ID.LINKING()
    commit('SET_SCIENCE_ID_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_SCIENCE_ID_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCIENCE_ID_LOADING_END')
        catcher(data, url)
      }
    )
  },
  getScienceId: ({ commit }, { url, science_id, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) url = url = mendeleev.SCIENCE_ID.REGISTER_GET(science_id)
    sendGetRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_SCIENCE_ID_ERROR', data)
        catcher(data, url)
      }
    )
  },
  redirectTo: ({ commit }, { url, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) url = url = mendeleev.SCIENCE_ID.REDIRECTTO()
    sendGetRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_SCIENCE_ID_ERROR', data)
        catcher(data, url)
      }
    )
  },
}

const mutations = {
  SET_SCIENCE_ID: (state, value) => {
    state.scienceId.items = value
  },
  SET_SCIENCE_ID_INFO: (state, value) => {
    state.scienceId.info = value
  },
  SET_SCIENCE_ID_LOADING: (state) => {
    state.scienceId.loading = true
  },
  SET_SCIENCE_ID_LOADING_END: (state) => {
    state.scienceId.loading = false
  },
  SAVE_SCIENCE_ID_ERROR: (state, error) => {
    state.scienceId.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
